import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from '../services/sessionService';

/**
 * PrivateRoute Component
 * Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */
export const PrivateRoute = ({ component: Component, ...rest }) => {
  // Handle both single component and array of components
  const renderComponent = (props) => {
    // Support multiple components (rarely used)
    if (Array.isArray(Component)) {
      return Component.map((comp, key) => (
        React.createElement(comp, {
          ...props,
          key: `${key}-private-route-${rest.path}`,
        })
      ));
    }

    // Single component
    return <Component {...props} />;
  };

  return isAuthenticated() ? (
    <Route {...rest} render={renderComponent} />
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { referrer: rest.path },
      }}
    />
  );
};